import { Button, Empty, Input } from 'antd';
import styles from './index.module.scss'
import { PlusOutlined } from '@ant-design/icons';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { VideoContext } from '../../hooks/VideoContext';
import Utils from '@/utils/utils';

export default function VideoLabels(props) {
    const { src, readonly, onLabel } = props;
    const [labels, setLabels] = useState((props.labels || []).filter(item => !!item?.snapshot))
    const [loading, setLoading] = useState(false)
    const isMountedRef = useRef(true)
    const {currentTime} = useContext(VideoContext)
    useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])
    // 截取当前帧
    const handleAddLabel = useCallback(async () => {
        try {
            setLoading(true)
            const url = await Utils.getVideoFrameImage(src, currentTime)
            if (!url) return
            if (!isMountedRef.current) return
            setLabels(pre => {
                const newLabels = [...pre, {
                    snapshot: url,
                    time: currentTime.toString(),
                    label: ""
                }]
                onLabel(newLabels)
                return newLabels
            })
        } catch (err) {
            console.error(err)
        } finally {
            if (isMountedRef.current) {
                setLoading(false)
            }
        }
    }, [currentTime, onLabel, src])
    // 描述问题
    const handleLabelChange = useCallback((value, index) => {
        setLabels(pre => {
            const newLabels = [...pre]
            newLabels[index].label = value
            onLabel(newLabels)
            return newLabels
        })
    }, [onLabel])
    // 删除问题
    const handleDelete = useCallback((index) => {
        setLabels(pre => {
            const newLabels = [...pre]
            newLabels.splice(index, 1)            
            onLabel(newLabels)
            return newLabels
        })
    }, [onLabel])

    return (
        <div className={styles.VideoLabels}>
            {
                !readonly ?
                <Button
                    loading={loading}
                    icon={<PlusOutlined />}
                    onClick={handleAddLabel}
                >截取当前帧并描述问题</Button> :
                null
            } {
                labels.length ?
                <div className={`${styles.VideoLabelList} _beauty_scrollbar`}>
                {
                    labels.sort((a, b) => a.time - b.time).map((item, index) => (
                        <VideoLabelItem
                            key={item.snapshot}
                            item={item}
                            readonly={readonly}
                            pureText={item.comment}
                            onChange={value => handleLabelChange(value, index)}
                            onDelete={() => handleDelete(index)}
                        />
                    ))
                }
                </div> :
                <div className={styles.PlaceHolder}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} size="small" />
                </div>
            }
        </div>
    )
}

/**
 * 总是显示完整格式，小时部分也补零
 */
function secondsToFullTimeString(seconds, showMilliseconds = false) {
    if (typeof seconds !== 'number' || isNaN(seconds) || !isFinite(seconds)) {
        return '00:00:00' + (showMilliseconds ? '.000' : '');
    }

    const isNegative = seconds < 0;
    const absSeconds = Math.abs(seconds);

    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);
    const secs = Math.floor(absSeconds % 60);
    const milliseconds = Math.round((absSeconds % 1) * 1000);

    const formatNumber = (num) => num.toString().padStart(2, '0');

    let timeString = formatNumber(hours) + ':' + formatNumber(minutes) + ':' + formatNumber(secs);

    if (showMilliseconds) {
        timeString += '.' + milliseconds.toString().padStart(3, '0');
    }

    if (isNegative) {
        timeString = '-' + timeString;
    }
    
    return timeString;
}
function VideoLabelItem (props) {
    const { item, readonly, pureText, onChange, onDelete } = props
    return (
        <div className={styles.VideoLabelItem}>
            {pureText ? null : <span className={styles.Time}>{secondsToFullTimeString(Number(item?.time))}</span>}
            {pureText ? null : <img className={styles.FrameImage} src={item.snapshot} width={80} />}
            <Input.TextArea
                className={styles.LabelInput}
                disabled={readonly}
                placeholder='请描述待修改的问题'
                value={pureText ? item.comment : item.label}
                onChange={e => onChange(e.target.value)}
                onBlur={e => onChange(e.target.value.trim())}
                onMouseLeave={e => e.stopPropagation()}
            />
            {readonly ? null : <span className={styles.DeleteButton} onClick={onDelete}></span>}
        </div>
    )
}
